<template>
  <div class="flex h-full">
    <el-tabs v-model="activeName" tab-position="left" class="w-152px h-90px ">
      <el-tab-pane label="安全工具器" name="securityTools"> </el-tab-pane>
      <el-tab-pane label="劳保用品" name="laborSupplies"> </el-tab-pane>
    </el-tabs>
    <div class="ml-10px flex-1 h-full overflow-hidden">
      <SecurityTools
        v-if="activeName === 'securityTools'"
        :orgId="orgId"
        :contractorId="contractorId"
      />
      <LaborSupplies v-if="activeName === 'laborSupplies'" :contractorId="contractorId" />
    </div>
  </div>
</template>
<script>
import SecurityTools from './securityTools'
import LaborSupplies from './laborSupplies'

export default {
  components: {
    SecurityTools,
    LaborSupplies,
  },
  props: {
    contractorId: {
      type: String,
      default: '',
    },
    orgId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeName: 'securityTools',
    }
  },
}
</script>
